import Upload from "../../../assets/icon/NewsIcons/MainAdmin/NewsUploadSmall"
import React, { useState, useEffect, useRef } from "react";
import { axiosReq } from "../../../commons/axiosReq";
const MainAdminAddSocialNetworks =  ({data})=> {
      const [allValues, setAllValues] = useState({
                SocialName: data ? data.socialName : '',
                Link: data ? data.link : '',
      
        
            });
            const changeHandler = e => {
                if (e.target) {
                 
                    // setAllValuesError({ ...allValuesError, [""]: false })
        
        
                    setAllValues({ ...allValues, [e.target.name]: e.target.value })
                }
            }
             const editIndex = async () => {        
                    // setSnipper(true)
                   
                  
                     
                        const dataUser = await axiosReq("Admins/UpdateSocial", "put", {
                            SocialId: data?.socialId,
                            SocialName: allValues?.SocialName,
                            Link: allValues?.Link,
                         
            
                        });
                        console.log(dataUser)
                        if (dataUser?.status == 200 || dataUser?.status == 204 || dataUser?.status == 201) {
            
                            //   navigate("/newRequestStep2/" + dataUser?.data?.requestId)
                            alert("موفقیت آمیز");
                        }
                        else {
                            alert("خطا");
    
                        }
                    
                   
                }
    return(
        <div className="flex justify-start items-end">
            <div className="w-[27%] ml-[1%]">
            <p className="text-[15px] font-IRANYekanExtra text-mainColor2 mb-[10px]">عنوان شبکه اجتماعی</p>
            <input  value={allValues?.SocialName}
            name="SocialName"   
                 onChange={changeHandler}
                 className="h-[35px]  w-full focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray" type="text" placeholder="عنوان شبکه اجتماعی را بنویسید" />
            </div>
            <div className="w-[42%] ml-[1%]">
            <p className="text-[15px] font-IRANYekanExtra text-mainColor2 mb-[10px]">لینک شبکه اجتماعی</p>
            <input  value={allValues?.Link}
            name="Link"   
                 onChange={changeHandler}
                  className="h-[35px]  w-full focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray" type="text" placeholder="لینک شبکه اجتماعی را بنویسید" />
            </div>
       
            <div className="w-[8%] ">
            <button onClick={()=>editIndex()} className="w-full h-[35px] bg-Orange2 shadow-norm-shadow rounded-[10px] flex justify-center items-center ">
                <p className="font-IRANYekanBold text-[15px] text-white">ثبت</p>
            </button>
            </div>
        </div>
    )
}

export default MainAdminAddSocialNetworks;